<div class="pt-5">
    <keep-triage-action [selectedLabels]="task.labels ? task.labels : []"
                        [selectedAssignees]="task.assignees ? task.assignees : []"
                        [managers]="managers"
                        (keep)="keepAction($event)"></keep-triage-action>

    <div class="btn-separator"></div>

    <button class="btn px-2 mb-1 mx-auto d-flex align-items-center action-item btn-skip" (click)="skipAction()">
        <div class="action-item-icon">
            <i class="fa-regular fa-box-archive"></i>
        </div>
        <div class="action-item-content text-start px-2">
            <span class="action-item-title">{{'task_action.skip' | translate }}</span>
            <span class="action-item-desc">{{'task_action.skip_desc' | translate }}</span>
        </div>
    </button>
</div>




